// //convertPropertyNames - camelCase Content
var pascalCasePattern = new RegExp("^([A-Z])([a-z]+)")
var lowerCamelPattern = new RegExp("[a-z]+((\d)|([A-Z0-9][a-z0-9]+))*([A-Z])?")
function pascalCaseToCamelCase(propname: any) {
  if (pascalCasePattern.test(propname)) {
    return propname.charAt(0).toLowerCase() + propname.slice(1)
  }
  else {
    return propname;
  }
}

export const camelCaseToPascalCase = (propname: any): any => {
  if (lowerCamelPattern.test(propname)) {
    return propname.charAt(0).toUpperCase() + propname.slice(1)
  }
  else {
    return propname;
  }
}


function convertPropNamesFn(obj: any, converterFn: any): any {
  // Used to convert property names into Pascal Casing
  // If we want other casings, we can cadd a new converterFn, as a prop on the convertPropertyNames function
  var r, value, t = Object.prototype.toString.apply(obj)
  if (t == "[object Object]") {
    r = {}
    for (var propname in obj) {
      value = obj[propname]
      // @ts-ignore
      r[converterFn(propname)] = convertPropNamesFn(value, converterFn)
    }
    return r
  }
  else if (t == "[object Array]") {
    r = []
    for (var i=0, L=obj.length; i<L; ++i ) {
      value = obj[i]
      r[i] = convertPropNamesFn(value, converterFn)
    }
    return r
  }
  return obj
}

export const convertPropertyNames = (obj: any, casing?: any): any => {
  // Use casing if we get it, else we use the fallback pascalCaseToCamelCase
  const useCasing = casing !== undefined ? casing : pascalCaseToCamelCase
  return convertPropNamesFn(obj, useCasing)
}